import * as Yup from "yup";

const LoginSchema = Yup.object({
    email : Yup.string().email().required('This field is required!'),
    password : Yup.string().required('This field is required!'),
});

export const RegisterSchema = Yup.object({
    name : Yup.string().min(2).max(25).required('This field is required!'),
    phone : Yup.number().required('This field is required!').nullable().typeError('Please enter a valid phone number!'),
    email : Yup.string().email().required('This field is required!'),
    password : Yup.string().required('This field is required!'),
})

export const ResetPasswordSchema = Yup.object({
    email : Yup.string().email().required('Email is required!'),
})

export default LoginSchema